import React from 'react';
import config from '../../config';

const ShopLink = () => {
  const url = config.squireShopUrl;

  return (
    <div className="u-mt">
      <a className="c-btn c-btn--secondary c-btn--small" href={`http://${url}.getsquire.com/`}>For barbers</a>
    </div>
  );
};

module.exports = ShopLink;



// WEBPACK FOOTER //
// ./src/app/components/SquireShopLink.jsx